import React, { useCallback, useRef, useState } from 'react';
import classNames from 'classnames';
import { Button, SelectPicture, Card, CardContent, Distribute, Divider, makeStyles, Menu, MenuContainer, MenuItem, MoreVert, Typography, CardImage, CheckOutline, } from "../../index";
import { useTranslation } from "../../hooks/useTranslation";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        width: 240,
        height: 200,
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        textDecoration: 'none',
    },
    title: {
        flex: '0 0 auto',
        display: 'flex,',
    },
    content: {
        flex: '1 0 0',
        display: 'flex',
        color: theme.palette.common.black,
    },
    textContent: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        minWidth: 0,
        paddingRight: 6,
    },
    menuButton: {
        flex: '0 0 auto',
        width: 48,
        minWidth: 0,
        padding: 0,
        margin: theme.spacing(-1),
    },
    selected: {
        boxShadow: '0 0 0 4px',
        color: theme.palette.primary.main,
        borderRadius: 2,
    },
    assignmentIcon: {
        position: 'absolute',
        right: 0,
        top: 0,
        width: 48,
        minWidth: 0,
        padding: 0,
        '& > svg': {
            color: theme.palette.common.black,
        },
    },
    authorName: {
        position: 'absolute',
        right: theme.spacing(1),
        bottom: 65,
    },
    thumbnail: {
        width: '100%',
        height: 135,
    },
    blankThumbnail: {
        width: '100%',
        height: '100%',
        color: theme.palette.background.default,
    },
    checkOutline: {
        margin: 'auto',
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0,
        width: 104,
        height: 104,
    },
}); });
export var FileSelectCard = React.memo(function (props) {
    var _a;
    var title = props.title, subtitle = props.subtitle, authorName = props.authorName, thumbnailLink = props.thumbnailLink, openLink = props.openLink, selected = props.selected, isLinkedAssignment = props.isLinkedAssignment, onSelect = props.onSelect;
    var classes = useStyles();
    var t = useTranslation().t;
    var _b = useState(false), isOpenMenu = _b[0], setIsOpenMenu = _b[1];
    var _c = useState(false), isFailedLoadingImage = _c[0], setIsFailedLoadingImage = _c[1];
    var _d = useState(null), menuAnchorRef = _d[0], setMenuAnchorRef = _d[1];
    var className = classNames(classes.root, (_a = {},
        _a[classes.selected] = selected,
        _a));
    var menuContainerRef = useRef(null);
    var handleClick = useCallback(function (event) {
        var _a;
        // メニューの要素やその子要素をクリックした際はonSelectを呼ばない。
        // 本来はstopPropagationを使いたいが、画面によってメニューが閉じなくなる現象が起きたため、refによる実装にしている。
        // stopPropagationを使った場合のバグはuikit上では発生しなかった。
        // 変更する際はノートアプリに導入した状態でも確認すること。
        if (!((_a = menuContainerRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)))
            onSelect === null || onSelect === void 0 ? void 0 : onSelect();
    }, [onSelect]);
    var handleToggleIsOpenMenu = useCallback(function (event) {
        setIsOpenMenu(function (prev) { return !prev; });
        event.preventDefault();
    }, []);
    // FIXME #90 今はコールバックを使用して別タブを開いているが、MenuItemにリンクが付けられるようになったらその形に直す
    var handleOpenFile = useCallback(function (event) {
        window.open(openLink, '_blank');
        setIsOpenMenu(false);
        event.preventDefault();
    }, [openLink]);
    var handleCloseMenu = useCallback(function () {
        setIsOpenMenu(false);
    }, []);
    var handleFailedLoadingImage = useCallback(function () {
        setIsFailedLoadingImage(true);
    }, []);
    return (React.createElement(Card, { onClick: handleClick, className: className },
        authorName && (React.createElement(Typography, { variant: "caption", component: "span", className: classes.authorName }, authorName)),
        isLinkedAssignment && (React.createElement("span", { className: classes.assignmentIcon },
            React.createElement(Distribute, { height: 48, width: 48 }))),
        React.createElement("div", { className: classes.thumbnail }, thumbnailLink && !isFailedLoadingImage ? (React.createElement(CardImage, { src: thumbnailLink, onFailedLoadingImage: handleFailedLoadingImage })) : (React.createElement(SelectPicture, { className: classes.blankThumbnail }))),
        selected && React.createElement(CheckOutline, { className: classes.checkOutline }),
        React.createElement(Divider, { thin: true }),
        React.createElement(CardContent, { className: classes.content },
            React.createElement("div", { className: classes.textContent },
                React.createElement(Typography, { variant: "body2", bold: true, noWrap: true }, title),
                React.createElement(Typography, { variant: "minimum", noWrap: true }, subtitle)),
            React.createElement(MenuContainer, { ref: menuContainerRef },
                React.createElement(Button, { ref: setMenuAnchorRef, onClick: handleToggleIsOpenMenu, className: classes.menuButton },
                    React.createElement(MoreVert, null)),
                React.createElement(Menu, { open: isOpenMenu, anchorEl: menuAnchorRef, placement: "bottom-end", onClose: handleCloseMenu },
                    React.createElement(MenuItem, { onClick: handleOpenFile }, t('開く')))))));
});
